import React from "react";
import "@/App.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProgramProvider } from "@/contexts/ProgramContext";
import ProgramHeader from "@/components/program/ProgramHeader";

// Layout components
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import AppRouter from "@/components/layout/AppRouter";
import TourManager from "@/components/layout/TourManager";
import MaintenanceBanner from "@/components/layout/MaintenanceBanner";
import BetaBanner from "@/components/layout/BetaBanner";
import ImpersonationBanner from "@/components/layout/ImpersonationBanner";
import DemoDistrictBanner from "@/components/layout/DemoDistrictBanner";
import MoiHelpBot from "@/components/MoiHelpBot";

// Routes that intentionally render WITHOUT the main MOSAIC chrome
// (top nav / footer / banners). The Teacher Portal is sold as a
// stand-alone, print-only experience for teachers and is hidden from
// every other part of the app.
const NO_CHROME_PREFIXES = ["/teacher-portal", "/m/parent", "/usb-edition", "/demo/usb", "/te-preview"];

function isNoChromeRoute(pathname) {
  return NO_CHROME_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p + "/")
  );
}

function ChromeShell() {
  const { pathname } = useLocation();
  const noChrome = isNoChromeRoute(pathname);
  return (
    <>
      {!noChrome && <ImpersonationBanner />}
      {!noChrome && <DemoDistrictBanner />}
      {!noChrome && <BetaBanner />}
      {!noChrome && <MaintenanceBanner />}
      {!noChrome && <Navigation />}
      {/* v6.32.142 — Persistent MOSAIC program header (Sprint 1 Workstream B).
          Renders nothing until the user picks a program via /program/switch.
          Lets customers flip between MOSAIC Practice and MOSAIC Summative
          without losing their place. */}
      {!noChrome && <ProgramHeader />}
      <main className="flex-1 min-w-0 w-full overflow-x-clip">
        <AppRouter />
      </main>
      {!noChrome && <Footer />}
      {!noChrome && <TourManager />}
      {/* v6.32.100 — MOI floating help bot. Renders nothing when signed-out
          per operator scoping. Hidden on no-chrome surfaces (Teacher Portal). */}
      {!noChrome && <MoiHelpBot />}
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <AuthProvider>
          <ProgramProvider>
            <ChromeShell />
          </ProgramProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
